/** De kleur van een diffregel (EG2), gedeeld door RepoDetail en RepoTakken (EG3). PUUR. */
export function diffKleur(regel) {
  if (regel.startsWith("+++") || regel.startsWith("---")) return "text-muted-foreground";
  if (regel.startsWith("+")) return "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300";
  if (regel.startsWith("-")) return "bg-red-500/10 text-red-700 dark:text-red-300";
  if (regel.startsWith("@@")) return "text-sky-700 dark:text-sky-300";
  return "";
}
